import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CarouselComponent, CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import * as $ from 'jquery';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { NavigationPopupComponent } from '../navigation-popup/navigation-popup.component';
import { CreditInsightsDetailsComponent } from '../credit-insights-details/credit-insights-details.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-credit-insights-details-slider',
  templateUrl: './credit-insights-details-slider.component.html',
  styleUrls: ['./credit-insights-details-slider.component.css'],
  standalone: true,
  imports: [NavigationPopupComponent,CreditInsightsDetailsComponent,CarouselModule, CommonModule]
})
export class CreditInsightsDetailsSliderComponent implements OnInit {
  @ViewChild('navigationPop', { static: true }) navigationPop: ElementRef;
  modalOptions: NgbModalOptions;
  creditInsightModel: any;
  startIndex: number = 5;
  isPopupShown: boolean = false;
  constructor(private modalService: NgbModal, private route: ActivatedRoute) { }

  ngOnInit(): void {
    const navsessionflag = sessionStorage.getItem('popupShown');
    this.isPopupShown = (navsessionflag === 'true'); 
    this.route.queryParams.subscribe({
        next: params => {
      this.startIndex = params['cg'];
    }});
    const storedData = sessionStorage.getItem('creditInsightModel');
    if (storedData) {

      var sData=JSON.parse(storedData);
      if(sData!=null){
        this.creditInsightModel = sData?.creditInsightModel;
        console.log("Shubham ",this.creditInsightModel);
        }
    }
    this.modalOptions = {
      backdrop: 'static',
      //backdropClass: 'bg-transparent',
      keyboard: false,
      windowClass: 'navigation-popup',
      centered: true,
      fullscreen: true,
      scrollable: true
    };
    if(this.isPopupShown){
      this.modalService.dismissAll(); 
    }
    else{
    this.modalService.open(this.navigationPop, this.modalOptions);
    }
    this.carouselNormalization();

  }
  carouselNormalization() {
    var windowh = $(window).height(),
    desiredHeight = windowh;
    $('.navigationPopheight').css("min-height", desiredHeight + 'px');
  }
  
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 900,
    navText: ['', ''],
    startPosition: 'URLHash',
    nav: false,
    autoplay: false,
    autoplayHoverPause: false,
    margin:8,
    stagePadding: 0,
    smartSpeed:450,
    responsiveRefreshRate : 1000,
    autoHeight:true,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items:1
      },
      940: {
        items:1
      }
    },
   
   
  }

}
